__webpack_require__.p = "https://playground.typeright.com/";